module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-mobile-en.643ebbd5.png";